import genericAvatar from "assets/images/generic_avatar.jpg";
import { ErrorModal, PageContainer } from "components";
import { FacultyContactInfo, FacultySecondaryInfo } from "components/reusables";
import { AddEditFacultyModal } from "components/reusables/AddEditModals/AddEditFacultyModal";
import React, { useCallback, useState } from "react";
import { useAsync } from "react-async";
import { Button, Card, Col, Row } from "react-bootstrap";
import Img from "react-cool-img";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { getFacultyStory } from "services";
import { generateFullName, URLPaths } from "utilities";

export function AdminFacultyStoryDetails(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [isShowingEditTeacherModal, setIsShowingEditTeacherModal] = useState(false);
  const promiseFn = useCallback(() => getFacultyStory(id), [id]);
  const { data, error, isPending } = useAsync({ promiseFn });
  const teacher = data;
  const history = useHistory();

  const handleClick = () => {
    history.push("/map-view-admin");
  };

  if (!teacher && !isPending) return <Redirect to={URLPaths.map} />;

  return (
    <>
      <PageContainer>
        <div>
          {teacher && (
            <Row>
              <Col xs={3}>
                <Img
                  src={teacher.photoUrl || ""}
                  placeholder={genericAvatar}
                  alt={`${teacher.firstName} ${teacher.lastName}`}
                  width="100%"
                  loading="lazy"
                  className="img-circle"
                />
                <hr />
                <FacultySecondaryInfo facultyMember={teacher} direction="column" />
                <hr />
                <FacultyContactInfo facultyMember={teacher} />
              </Col>
              <Col>
                <Row>
                  <Col>
                    <h1>{generateFullName(teacher.firstName, teacher.lastName)} (Faculty) </h1>
                    <span>{`Faculty Since ${teacher.facultySince}`}</span>
                  </Col>

                  <Col xs="auto">
                    <Button onClick={handleClick} variant="outline-danger">
                      Go Back
                    </Button>
                  </Col>
                  <Col xs="auto">
                    <Button
                      variant="outline-success"
                      onClick={() => setIsShowingEditTeacherModal(true)}
                    >
                      Edit
                    </Button>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col xs={8}>
                    <h4>About</h4>
                    <p className="p-breaks">{teacher.bio}</p>
                  </Col>
                  <Col xs={4}>
                    {(teacher.quotes || []).length > 0 && (
                      <>
                        <h4>Quotes and Advice</h4>
                        <Card className="quotes">
                          <Card.Body>
                            {teacher.quotes?.map(quote => (
                              <FacultyQuote key={quote} quote={quote} />
                            ))}
                          </Card.Body>
                        </Card>
                      </>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
          <ErrorModal error={error} />
        </div>
      </PageContainer>
      {!!teacher && (
        <AddEditFacultyModal
          show={isShowingEditTeacherModal}
          setShow={setIsShowingEditTeacherModal}
          currentFaculty={teacher}
        />
      )}
    </>
  );
}

interface FacultyQuoteProps {
  quote: string;
}

function FacultyQuote({ quote }: FacultyQuoteProps): JSX.Element {
  return (
    <div className="quote d-flex flex-row">
      <span>&quot;{quote}&quot;</span>
    </div>
  );
}
